import React from 'react';
import { useSelector } from 'react-redux';
import { getCurrencySymbol, toFixedTrunc } from '../../../../client/Juno/helpers';

const SellConfirm = ({ formData, quotationData, exchangeLoading }) => {
    const { balancesCurrencies, balancesCrypto } = useSelector(state => state.juno);
    const imageBaseUrl = useSelector(state => state.config.image_base_url);
    const fiatIcon = balancesCurrencies.find(
        x => x.currencyShortName === formData.fiatCurrency,
    )?.currencyIcon;

    const fiatBalance = balancesCurrencies.find(
        x => x.currencyShortName === formData.fiatCurrency,
    )?.balanceAmount;

    const cryptoIcon = balancesCrypto.find(
        x => x.currencyShortName === formData.cryptoId,
    )?.currencyIcon;

    const cryptoBalance = balancesCrypto.find(
        x => x.currencyShortName === formData.cryptoId,
    )?.balanceAmount;

    return (
        <div className=" text-[#FFFFFF] px-2 rounded-lg w-full ">
            {/* SELL Block */}
            <div>
                <p className="text-[12px] font-Inter font-medium text-balanceCard-manage  mb-1">
                    SELL
                </p>
                <div className="bg-card-bg border-[1px] !border-[#D1D1D6] dark:!border-[#51525C] p-3 w-full h-[85px] rounded-lg mb-4">
                    <div className="flex items-center justify-between ">
                        <div className="flex items-center gap-2">
                            <img
                                src={cryptoIcon ? `${imageBaseUrl}${cryptoIcon}` : ''}
                                alt="crypto"
                                width={24}
                                height={24}
                                className="rounded-full"
                            />
                            <span className="!text-text font-medium">{formData.cryptoId}</span>
                        </div>
                        <p className="!text-text font-semibold" data-e2e='sell-confirm-amount'>
                            {getCurrencySymbol(formData.cryptoId)}{' '}
                            {formData.cryptoAmount} ({formData.cryptoId})
                        </p>
                    </div>
                    <div className="my-2 h-px w-full !bg-[#D1D1D6] dark:!bg-[#51525C]"></div>
                    <div className="flex items-center justify-between">
                        <span className="text-[12px] font-Inter font-medium text-balanceCard-manage">
                            BALANCE:
                        </span>
                        <p className="text-[12px] font-Inter font-medium text-balanceCard-manage">
                            {getCurrencySymbol(formData.cryptoId)} {toFixedTrunc(cryptoBalance, 8)}{' '}
                            ({formData.cryptoId})
                        </p>
                    </div>
                </div>
            </div>

            {/* RECEIVE Block */}
            <div>
                <p className="text-[12px] font-Inter font-medium text-balanceCard-manage mb-1">
                    RECEIVE
                </p>
                <div className="bg-card-bg rounded-lg p-3 mb-4 border-[1px] !border-[#D1D1D6] dark:!border-[#51525C]  w-full h-[85px]">
                    <div className="flex items-center justify-between ">
                        <div className="flex items-center gap-2">
                            <img
                                src={fiatIcon ? `${imageBaseUrl}${fiatIcon}` : ''}
                                alt="fiat"
                                width={24}
                                height={24}
                                className="rounded-full"
                            />
                            <span className="!text-text font-medium">{formData.fiatCurrency}</span>
                        </div>
                        <p className="!text-text font-semibold" data-e2e='receive-confirm-amount'>
                            {getCurrencySymbol(formData.fiatCurrency)}{' '}
                            {formData.fiatAmount} ({formData.fiatCurrency})
                        </p>
                    </div>
                    <div className="my-2 h-px w-full !bg-[#D1D1D6] dark:!bg-[#51525C] "></div>
                    <div className="flex items-center justify-between">
                        <span className="text-[12px] font-Inter font-medium text-balanceCard-manage">
                            BALANCE:
                        </span>
                        <p className="text-[12px] font-Inter font-medium text-balanceCard-manage">
                            {getCurrencySymbol(formData.fiatCurrency)}{' '}
                            {toFixedTrunc(fiatBalance, 2)} ({formData.fiatCurrency})
                        </p>
                    </div>
                </div>
            </div>

            {/* Rate Info */}
            <div className="flex items-center justify-center bg-card-bg py-3 px-4 rounded-lg mb-6 w-full h-[36px]">
                <div className="flex items-center gap-2 text-sm">
                    {exchangeLoading && (
                        <div className="animate-spin h-[18px] w-[18px] border-2 border-[#A0A0AB4D] rounded-full border-t-2 !border-t-primary" />
                    )}
                    <span className="text-[14px] font-Inter font-medium !text-text">
                        1 {formData.cryptoId} = {toFixedTrunc(quotationData?.price, 2)}{' '}
                        {formData.fiatCurrency}
                    </span>
                </div>
            </div>

            {quotationData?.error && (
                <div className="mt-4 text-red-500 text-sm text-center">
                    Error while fetching quotation
                </div>
            )}
        </div>
    );
};

export default SellConfirm;
